const SKIP_KEYS = new Set(['draft_updated_at', 'id', 'created_at', 'updated_at']);

export const FIELD_LABELS = {
  zone_times: 'Heures de zone',
  ecoles_controle: 'Écoles',
  ecoles_ras: 'RAS écoles',
  ecoles_remarks: 'Remarques écoles',
  etage2_controle: '2ème étage',
  reception_controle: 'Réception',
  restaurant_controle: 'Restaurant',
  cuisine_controle: 'Cuisine',
  sous_sols_controle: 'Sous-sols',
  sous_sols_passages: 'Passages sous-sols',
  sous_sols_remarks: 'Remarques sous-sols',
  temperature_checks: 'Températures',
  manoeuvres: 'Manœuvres',
  manoeuvre_times: 'Heures des manœuvres',
  controle_exterieurs: 'Rondes extérieures',
  controle_internes_hotel: 'Rondes des étages',
  observations_etages: 'Observations',
  incidents: 'Incidents',
  shift_start: 'Prise de service',
  shift_end: 'Fin de service',
  reception_name: 'Réception',
  material_checklist: 'Matériel',
};

export function stableStringify(value) {
  if (Array.isArray(value)) {
    return `[${value.map((item) => stableStringify(item)).join(',')}]`;
  }
  if (value && typeof value === 'object') {
    return `{${Object.keys(value).sort().map((key) => `${JSON.stringify(key)}:${stableStringify(value[key])}`).join(',')}}`;
  }
  return JSON.stringify(value ?? null);
}

export function isBlank(value) {
  if (value == null || value === '' || value === false) return true;
  if (Array.isArray(value)) return value.every((item) => item == null || item === '');
  if (typeof value === 'object') return Object.values(value).every((item) => isBlank(item));
  return false;
}

/**
 * Fusion à trois versions.
 * Avec une base connue : on garde le côté qui a changé.
 * Sans base : un champ vide ne recouvre pas l'autre version.
 * Si les deux ont changé le même champ, la saisie locale (téléphone) est gardée
 * et le champ est signalé.
 */
export function threeWayMerge(base, local, remote) {
  const left = base && typeof base === 'object' ? base : {};
  const mine = local && typeof local === 'object' ? local : {};
  const theirs = remote && typeof remote === 'object' ? remote : {};
  const hasBase = !!(base && typeof base === 'object' && Object.keys(base).length);
  const keys = new Set([...Object.keys(left), ...Object.keys(mine), ...Object.keys(theirs)]);
  const merged = { ...theirs };
  const conflicts = [];

  keys.forEach((key) => {
    if (SKIP_KEYS.has(key)) return;
    const baseValue = stableStringify(left[key] ?? null);
    const localValue = stableStringify(mine[key] ?? null);
    const remoteValue = stableStringify(theirs[key] ?? null);
    if (localValue === remoteValue) {
      merged[key] = mine[key];
      return;
    }
    if (hasBase && localValue === baseValue) {
      merged[key] = theirs[key];
      return;
    }
    if (hasBase && remoteValue === baseValue) {
      merged[key] = mine[key];
      return;
    }
    if (!hasBase) {
      if (isBlank(mine[key]) && !isBlank(theirs[key])) {
        merged[key] = theirs[key];
        return;
      }
      if (!isBlank(mine[key]) && isBlank(theirs[key])) {
        merged[key] = mine[key];
        return;
      }
    }
    merged[key] = mine[key];
    conflicts.push(key);
  });

  return { merged, conflicts };
}

export function labelConflicts(keys) {
  return (keys || []).map((key) => FIELD_LABELS[key] || key);
}
